import { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import PropTypes from 'prop-types';

const MenuDropdown = ({ title, onClick, children }) => {
    const dropdownRef = useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleClick = (e) => {
        onClick && onClick(e, this);
        setIsDropdownOpen(!isDropdownOpen);
    }

    // Handle clicks outside of dropdowns
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative" ref={dropdownRef}>
            <button onClick={handleClick}
                className="flex items-center text-gray-700 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 px-3 py-2 text-sm font-medium">
                {title}
                <ChevronDown className="h-4 w-4 ml-1" />
            </button>
            {children && isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5">
                    <div className="py-1" role="menu" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                        {children}
                    </div>
                </div>
            )}
        </div>
    )
}

MenuDropdown.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    onClick: PropTypes.func,
}

export default MenuDropdown
